import React, { FC, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FilterableField,
  GroupedOptions,
} from 'components/organisms/tasks/fields';
import { GetFilterOperationTypeOptions } from 'components/organisms/tasks/filter-box/advanced';
import { GroupedFilter } from 'components/organisms/tasks/grouped-filter-popover';
import { defaultGroupedFilter } from 'components/organisms/tasks/utils';
import { FilterGroupType } from 'components/pages/types';
import { GroupedFilterDrawerBadges } from './grouped-badges';
import { GroupedFDrawer } from './grouped-drawer';
import { FilterTrigger } from './styles';

interface Props {
  fields: GroupedOptions<FilterableField>[];
  defaultGroup: FilterGroupType;
  onSubmit: (filter: GroupedFilter) => void;
  filter?: GroupedFilter;
  showMinimumBadges?: boolean;
  getFilterOperationTypeOptions?: GetFilterOperationTypeOptions;
  filterTriggerText?: React.ReactNode;
  filterTriggerClassName?: string;
  title?: React.ReactNode;
}

export const GroupedFilterDrawer: FC<Props> = ({
  fields,
  defaultGroup,
  filter = defaultGroupedFilter(defaultGroup),
  onSubmit,
  showMinimumBadges,
  getFilterOperationTypeOptions,
  filterTriggerClassName = 'filter-trigger',
  filterTriggerText,
  title = <FormattedMessage id="add_conditions" />,
}) => {
  const [showConditionsDrawer, setShowConditionsDrawer] = useState(false);
  const onCloseDrawer = () => {
    setShowConditionsDrawer(false);
  };

  const onFilterDrawerSubmit = (_filter: GroupedFilter) => {
    onCloseDrawer();
    onSubmit(_filter);
  };

  return (
    <>
      <GroupedFDrawer
        fields={fields}
        filter={filter}
        onSubmit={onFilterDrawerSubmit}
        title={title}
        visible={showConditionsDrawer}
        onClose={onCloseDrawer}
        getFilterOperationTypeOptions={getFilterOperationTypeOptions}
      />
      <GroupedFilterDrawerBadges
        filter={filter}
        showMinimumBadges={showMinimumBadges}
      />
      <FilterTrigger
        type="link"
        onClick={() => setShowConditionsDrawer(true)}
        data-cy="filter_drawer.filter.trigger"
        className={filterTriggerClassName}
      >
        {filterTriggerText ?? <FormattedMessage id="add_conditions" />}
      </FilterTrigger>
    </>
  );
};
